import React, { useState } from "react";
import {
  formatBulletList,
  formatNumberedList,
  formatHeading,
  formatParagraph,
  formatQuote,
} from "./BlogToolbarUtils";
import { SHORTCUTS } from "./ShorotcutsPluging";
import { blockTypeToBlockName } from "./ToolbarContext";

export default function BlockFormatDropDown({ editor, blockType, open, setOpen, dropdownRef }) {
  const [selected, setSelected] = useState(
    blockTypeToBlockName[blockType] || "Normal"
  );

  const handleSelect = (name, action) => {
    setSelected(name);
    action();
  };

  const items = [
    {
      name: "Normal",
      action: () => formatParagraph(editor),
      shortcut: SHORTCUTS.NORMAL,
    },
    {
      name: "Heading 1",
      action: () => formatHeading(editor, blockType, "h1"),
      shortcut: SHORTCUTS.HEADING1,
    },
    {
      name: "Heading 2",
      action: () => formatHeading(editor, blockType, "h2"),
      shortcut: SHORTCUTS.HEADING2,
    },
    {
      name: "Heading 3",
      action: () => formatHeading(editor, blockType, "h3"),
      shortcut: SHORTCUTS.HEADING3,
    },
    {
      name: "Heading 4",
      action: () => formatHeading(editor, blockType, "h4"),
      shortcut: SHORTCUTS.HEADING4,
    },
    {
      name: "Heading 5",
      action: () => formatHeading(editor, blockType, "h5"),
      shortcut: SHORTCUTS.HEADING5,
    },
    {
      name: "Heading 6",
      action: () => formatHeading(editor, blockType, "h6"),
      shortcut: SHORTCUTS.HEADING6,
    },
    {
      name: "Numbered List",
      action: () => formatNumberedList(editor, blockType),
      shortcut: SHORTCUTS.NUMBERED_LIST,
    },
    {
      name: "Bullet List",
      action: () => formatBulletList(editor, blockType),
      shortcut: SHORTCUTS.BULLET_LIST,
    },
    {
      name: "Quote",
      action: () => formatQuote(editor, blockType),
      shortcut: SHORTCUTS.QUOTE,
    },
  ];

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-24 md:w-36 px-1.5 md:px-2 py-1.5 md:py-2 text-sm font-medium border rounded-md bg-white border-gray-200 hover:bg-gray-50"
      >
        {selected}
        <svg
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-56 rounded-md border border-gray-200 bg-white shadow-md z-10">
          <div className="px-3 py-2 text-xs font-semibold text-gray-500">
            Block type
          </div>
          <div className="border-t border-gray-100" />

          {items.map((item) => (
            <div
              key={item.name}
              onClick={() => handleSelect(item.name, item.action)}
              className="flex justify-between items-center px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
            >
              <span>{item.name}</span>
              <span className="text-gray-400 text-xs">{item.shortcut}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
